/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Nativelanguage_Tahitianisch2Inputs */

const en__field__enum_nativelanguage_tahitianisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Tahitianisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahitianisch`)
};

const de__field__enum_nativelanguage_tahitianisch2 = /** @type {(inputs: _Field__Enum_Nativelanguage_Tahitianisch2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahitianisch`)
};

/**
* | output |
* | --- |
* | "Tahitianisch" |
*
* @param {_Field__Enum_Nativelanguage_Tahitianisch2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_nativelanguage_tahitianisch2 = /** @type {((inputs?: _Field__Enum_Nativelanguage_Tahitianisch2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Nativelanguage_Tahitianisch2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_nativelanguage_tahitianisch2(inputs)
	return de__field__enum_nativelanguage_tahitianisch2(inputs)
});
export { _field__enum_nativelanguage_tahitianisch2 as "_field__enum_nativeLanguage_Tahitianisch" }